import { DashboardCardResponseModel } from './../business-entities/card-count-view-model';
import { DashboardDataService } from './../data-services/dashboard-data.service';
import { Injectable } from '@angular/core';
import { StatusViewModel } from '../business-entities/status-view-model';
import { CallNoteRequestModel } from '../business-entities/call-note-request-model';
import { CallDialRequestModel,CallHangupRequestModel,CallTransferRequestModel } from '../business-entities/call-request-model';
import * as Enums from 'projects/Autofacets-Core/src/app/utils/enums';
import { NotificationRequestViewModel } from '../business-entities/notification-details-result-view-model';
import { AdditionalWorkStatus } from 'projects/Autofacets-Core/src/app/utils/enums';

@Injectable({ providedIn: 'root' })
export class DashboardService {
    public isFromDashboard: boolean = false;
    public WidgetAppointmentStatus: string = 'All';
    StatusList: StatusViewModel[] = [];
    constructor(
        private dashaboardDataService: DashboardDataService
    ) { }

    async getCardCounts(model: any) {

        let dashboardResponse: DashboardCardResponseModel;
        await this.dashaboardDataService.getCardCounts(model).then(response => {
            dashboardResponse = response.responseObject;
        });
        return dashboardResponse;
    }

    getStatusList() {
        this.StatusList = [];
        this.StatusList.push({ id: Enums.StatusCode.All, value: 'All' });
        this.StatusList.push({ id: Enums.StatusCode.Active, value: 'Active' });
        this.StatusList.push({ id: Enums.StatusCode.InActive, value: 'InActive' });
        return this.StatusList;
    }

    getDmsStatusList() {
        this.StatusList = [];
        this.StatusList.push({ id: Enums.DmsSync.All, value: 'All' });
        this.StatusList.push({ id: Enums.DmsSync.Success, value: 'Sync success' });
        this.StatusList.push({ id: Enums.DmsSync.Failed, value: 'Sync failed' });
        return this.StatusList;
    }

    async GetDealers(userId: string) {
        const response = await this.dashaboardDataService.getDealers(userId);
        return response?.responseObject ?? null;
    }
    async GetNotifications(requestModel:NotificationRequestViewModel) {
        const response = await this.dashaboardDataService.getNotifications(requestModel);
        return response?.responseObject ?? null;
    }
    async NotificationMarkAllAsRead(userId: string) {
        return this.dashaboardDataService.markAllAsRead(userId);
    }
    async notificationMarkAsRead(userId: string,id:number){
        return  this.dashaboardDataService.markAsRead(userId,id);
    }
    async GetCallHistory(model: any) {
        const response = await this.dashaboardDataService.getCallHistory(model);
        return response?.responseObject ?? null;
    }
    async GetCallerVehicle(customerId: number) {
        const response = await this.dashaboardDataService.getCallerVehicle(customerId);
        return response?.responseObject ?? null;
    }
    async saveCallNote(callNoteModel: CallNoteRequestModel) {
        return this.dashaboardDataService.saveCallNote(callNoteModel);
    }
    async callDial(requestModel: CallDialRequestModel) {
        return this.dashaboardDataService.callDial(requestModel);
    }
    async callTransfer(requestModel: CallTransferRequestModel) {
        return this.dashaboardDataService.callTransfer(requestModel);
    }
    async callHangup(requestModel: CallHangupRequestModel) {
        return this.dashaboardDataService.callHangup(requestModel);
    }
    async getSyncCounts() {
        let syncRes;
        await this.dashaboardDataService.getSyncCounts().then(response => {
            syncRes = response.responseObject;
        });
        return syncRes;
    }
    async getBrandWiseAppointment(model: any) {
        var data;
        await this.dashaboardDataService.getBrandWiseAppointment(model).then(response => {
            data =  response;
        });
        return data;
    }

    async getDealerWithNoAppointments(selectedDate: string) {
        const response = await this.dashaboardDataService.getDealerWithNoAppointments(selectedDate);
        return response?.responseObject ?? null;
    }
    
    getAdditionalWorkStatusList() {
        this.StatusList = [];
        this.StatusList.push({ id: AdditionalWorkStatus.All, value: 'All' });
        this.StatusList.push({ id: AdditionalWorkStatus.Reject, value: 'Reject' });
        this.StatusList.push({ id: AdditionalWorkStatus.Pending, value: 'Pending' });
        this.StatusList.push({ id: AdditionalWorkStatus.Approve, value: 'Approve' });
        return this.StatusList;
    }
}
